const DESKTOP_QUERY = '(min-width: 48rem)'

export const initializePartnerLogos = () => {
  const wrappers = document.querySelectorAll('[data-component="partner-logos-wrapper"]')
  if (!wrappers.length) return

  const mediaQuery = window.matchMedia(DESKTOP_QUERY)

  const instances = Array.from(wrappers).map(wrapper => ({
    wrapper,
    stage: wrapper.querySelector('[data-component="partner-logos-stage"]'),
    windowEl: wrapper.querySelector('[data-component="partner-logos-window"]'),
    track: wrapper.querySelector('[data-component="partner-logos-track"]'),
  }))

  const resetInstance = ({ wrapper, windowEl, track }) => {
    wrapper.style.height = ''
    track.style.transform = ''
    windowEl.classList.remove('partner-logos-fade-top', 'partner-logos-fade-bottom')
  }

  const scrollableDistanceOf = ({ windowEl, track }) =>
    Math.max(track.scrollHeight - windowEl.clientHeight, 0)

  const measureInstance = instance => {
    if (!mediaQuery.matches) {
      resetInstance(instance)
      return
    }
    instance.wrapper.style.height = `${instance.stage.offsetHeight + scrollableDistanceOf(instance)}px`
  }

  const updateInstance = ({ wrapper, stage, windowEl, track }) => {
    if (!mediaQuery.matches) return

    const scrollableDistance = scrollableDistanceOf({ windowEl, track })
    if (scrollableDistance <= 0) {
      track.style.transform = ''
      windowEl.classList.remove('partner-logos-fade-top', 'partner-logos-fade-bottom')
      return
    }

    const stickyTop = parseFloat(getComputedStyle(stage).top) || 0
    const wrapperTop = wrapper.getBoundingClientRect().top
    const progress = Math.min(Math.max((stickyTop - wrapperTop) / scrollableDistance, 0), 1)

    track.style.transform = `translateY(-${progress * scrollableDistance}px)`
    windowEl.classList.toggle('partner-logos-fade-top', progress > 0.01)
    windowEl.classList.toggle('partner-logos-fade-bottom', progress < 0.99)
  }

  const updateAll = () => instances.forEach(updateInstance)
  const measureAll = () => {
    instances.forEach(measureInstance)
    updateAll()
  }

  measureAll()
  window.addEventListener('scroll', updateAll, { passive: true })
  window.addEventListener('resize', measureAll)
  mediaQuery.addEventListener('change', measureAll)
}
